import { useEffect, useState } from "react";
import TextInput, { TextInputProps } from "../TextInput/TextInput";
import { checkValidity } from "../../../utils/inputValidityChecker";



export type TextInputSearchProps =  TextInputProps &{

    timeout?: number
    sendQuery?: (query: string | null) => void
    setIsLoading?: (isLoading: boolean) => void
    valueInit?: string | null
    onChangeCallback?: (query: string) => void
    onGetInitValue?: () => string | null | undefined
}

export default function TextInputSearch({timeout = 1000, sendQuery, setIsLoading, onChange: onChangeRaw, valueInit,value, onChangeCallback, ...rest}: TextInputSearchProps) {
    const [query, setQuery] = useState<string | null>(() =>valueInit || null);

    const [readyToSearch, setReadyToSearch] = useState(false);
  
    const minLenghtQuery = 0;
  
    useEffect(() => {
      if (valueInit) {
        setQuery(valueInit);
        sendQuery && sendQuery(valueInit);
      }
    }, [valueInit]); // eslint-disable-line

    useEffect(() => {
      if (readyToSearch && sendQuery) {
        sendQuery(query);
        (setIsLoading && setIsLoading(false));
      }
    }, [readyToSearch]); // eslint-disable-line
  
  
    const onSetQuery = (query: string) => {
      setQuery(query);
    onChangeCallback && onChangeCallback(query);
      

      if (query !== "" &&!checkValidity(query, "text-not-empty")) {
        return;
      }
  
      if (String(query).length >= minLenghtQuery) {
        setReadyToSearch(false);
        setTimeout(() => {
          setReadyToSearch(true);
        }, 1000);
      }
  
      (setIsLoading &&  setIsLoading(true));
      if (readyToSearch) {
        setReadyToSearch(false);
  
        setTimeout(() => {
          setReadyToSearch(true);
          (setIsLoading && setIsLoading(false));
        }, 1000);
      }
    };
    
  return (
    <TextInput {...rest} onChange={(e) => { onSetQuery(e.target.value)}} value={query} />
  )
}
